module.exports = __webpack_public_path__ + "img/1.bd5a7b4b.svg";